<div class="container my-5 login">

  <app-content [parent]="'SystemShopContent'" [location]="eContentLocation.Content"></app-content>
  <app-content [parent]="'Login'" [location]="eContentLocation.Above"></app-content>

  <div class="row m-0">

    @if (loginRequiresCookieAcceptance && !cookiesAreAccepted) {
      <div class="col-12 col-lg-6 p-3">
        <app-cookie-banner></app-cookie-banner>
      </div>
    }

    @if (loginRequiresCookieAcceptance != true || cookiesAreAccepted) {
      <form id="loginForm" class="pretty-container-blue p-4 m-auto col-12 col-lg-6" (ngSubmit)="loginClickAsync()">
        <h1 class="h4 fw-normal text-white" i18n="@@LoginHeading">Login</h1>
        <div class="mt-2">
          <label for="emailInputField" i18n="@@LoginEmailInputLabel" class="text-white">E-Mail</label>
          <input #emailInputField class="form-control mt-2" type="text" name="emailInput" required id="emailInputField"
            [(ngModel)]="coUserOrEmailOrAlias" #emailInput="ngModel" placeholder=" "
            (change)="coUserOrEmailOrAlias = coUserOrEmailOrAlias.trim()">
        </div>
        <div class="mt-2">
          <label for="passwordInputField" i18n="@@LoginPasswordInputLabel" class="text-white">Password</label>
          <div class="input-group mt-2">
            <input class="form-control" [type]="passwordShow ? 'text':'password'" name="passwordInput" required
              id="passwordInputField" [(ngModel)]="password" #passwordInput="ngModel" placeholder=" "
              autocomplete="off">
            <span class="input-group-text input-group-img">
              <div class="c-pointer">
                <i class="ms-1 bi" [ngClass]="passwordShow == true ? 'bi-eye' : 'bi-eye-slash'"
                (click)="passwordShowClick()"></i>
              </div>
            </span>
          </div>
        </div>
        <div class="mt-2">
          <a routerLink="/password-reset/linkSend">
            <span class="text-white fst-italic" i18n="@@LoginPasswordResetButton">Reset
              password</span>
          </a>
        </div>
        <div class="w-100 d-flex justify-content-end">
          <button class="btn btn-secondary btn-pretty mt-2" type="submit" i18n="@@LoginSubmitButton">Login</button>
        </div>
      </form>
    }

    <div class="col-12 col-lg-6 p-3">
      <h1 class="h4 fw-normal" i18n="@@LoginHeadingNoAccount">No account yet?</h1>
      <div class="mt-3">
        <span i18n="@@LoginOpenNewAccountText">
          Open your webshop account and order online in just a few clicks.
        </span>
      </div>
      <div class="mt-3">
        <a [routerLink]="['/register']" [queryParams]="{isCustomer: true}">
          <button class="btn btn-outline-secondary mt-2 whitespace-normal"
          i18n="@@LoginRegisterButton">Registration</button>
        </a>
      </div>
    </div>

  </div>

  <app-content [parent]="'Login'" [location]="eContentLocation.Below"></app-content>

</div>
